import { NavLink, useLocation } from 'react-router-dom';
import { useCart } from '../hooks/useCart';
import { HomeIcon, ShopIcon, TicketIcon, GiftIcon, UserIcon } from './icons';

const TABS = [
  { to: '/dashboard', label: 'หน้าหลัก',  Icon: HomeIcon },
  { to: '/shop',      label: 'ช้อป',     Icon: ShopIcon },
  { to: '/coupons',   label: 'คูปอง',    Icon: TicketIcon },
  { to: '/rewards',   label: 'แลกรางวัล', Icon: GiftIcon },
  { to: '/profile',   label: 'โปรไฟล์',   Icon: UserIcon },
] as const;

const HIDDEN_PATHS = new Set<string>(['/', '/register']);

export function BottomNav() {
  const { pathname } = useLocation();
  const cart = useCart();
  if (HIDDEN_PATHS.has(pathname)) return null;

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-black flex shadow-[0_-2px_12px_rgba(0,0,0,0.25)] z-50">
      {TABS.map((tab) => {
        const isShop = tab.to === '/shop';
        const isCartOrShop = pathname.startsWith('/shop');
        const Icon = tab.Icon;
        return (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) => {
              const active = isActive || (isShop && isCartOrShop);
              return `relative flex-1 flex flex-col items-center py-2.5 text-xs gap-1 ${
                active ? 'text-white' : 'text-white/40'
              }`;
            }}
          >
            <Icon className="w-5 h-5" />
            <span>{tab.label}</span>
            {isShop && cart.count > 0 && (
              <span className="absolute top-1 right-[calc(50%-22px)] bg-red-500 text-white text-[10px] font-bold rounded-full w-4 h-4 flex items-center justify-center">
                {cart.count > 9 ? '9+' : cart.count}
              </span>
            )}
          </NavLink>
        );
      })}
    </nav>
  );
}
